import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';

import { ReactComponent as DeleteIcon } from '../../../assets/images/delete.svg';
import { ReactComponent as DocumentIcon } from '../../../assets/images/document.svg';

import styles from './AttachFile.module.scss';

const AttachFile = ({ acceptedFiles = [], handleFileDelete, handleOnDrop, accept, DropzoneIcon }) => {
  const { t } = useTranslation('common');
  const { getRootProps, getInputProps, open } = useDropzone({
    accept,
    noClick: true,
    noKeyboard: true,
    multiple: false,
    onDrop: handleOnDrop,
  });

  return (
    <div>
      <div className={styles.dndWindow}>
        <div className={styles.dndZone}>
          <div
            {...getRootProps({
              className: styles.dropzone,
            })}
          >
            <input {...getInputProps()} />
            <div className={styles.dropzoneContent}>
              <DropzoneIcon />
              <div>
                <p>
                  {t('fileUpload.dragDropOr')}&nbsp;
                  <span onClick={open} role="presentation">
                    {t('fileUpload.chooseFile')}
                  </span>
                  &nbsp;{t('fileUpload.toUpload')}
                </p>
              </div>
              <div>{t('fileUpload.pdfOrWordDoc')}</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.fileList}>
        {acceptedFiles.map((file) => {
          const { _destroy } = file;
          if (!_destroy) {
            return (
              <div key={file.id ?? `${file.path}+${file.name}`}>
                <div>
                  <DocumentIcon />
                  <span className={styles.uploadedFileName}>{file.name ?? file[0].name}</span>
                </div>
                <div className={styles.deleteFile} onClick={() => handleFileDelete?.(file)} role="presentation">
                  <DeleteIcon />
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default AttachFile;
